@if ((activeDownloads$ | async)?.length) {
<div class="download-container">
  @for (download of activeDownloads$ | async; track download) {
  <div class="download-card" [ngClass]="download.state.toLowerCase()">
    <div class="download-info">
      <div class="filename" [title]="download.filename">{{ download.filename }}</div>
      <div class="status-text">
        @if (download.state === 'PENDING') {
        <span>Preparing...</span>
        }
        @if (download.state === 'IN_PROGRESS') {
        <span>Downloading... {{ download.progress }}%</span>
        }
        @if (download.state === 'COMPLETED') {
        <span>Completed</span>
        }
        @if (download.state === 'ERROR') {
        <span class="text-danger">Failed</span>
        }
      </div>
    </div>
    <div class="progress-bar-container">
      <div class="progress-bar" [style.width.%]="download.progress"
        [ngClass]="{'bg-success': download.state === 'COMPLETED', 'bg-danger': download.state === 'ERROR'}">
      </div>
    </div>
    @if (download.error) {
    <div class="error-msg">{{ download.error }}</div>
    }
  </div>
  }
</div>
}